import React, { useState } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import { Button,  Modal, Form } from 'react-bootstrap';
import axios from "axios";
import Scelta_tipologia_azienda from "./Ditta_x6_tipologia.jsx";

const Nuova_ditta = (props) => {
//    const [somma, calcola_somma] = useState('');
const [show, SET_show] = useState(false);

const handleClose = () => SET_show(false);
const handleShow = () => SET_show(true);
const [input, setInput] = useState({
    convenzione_in_archivio: false
});


function handleChange(event) {
//        event.preventDefault()
//        event.persist();
//    console.log(event.target)
    const { name, value, type } = event.target;
//    console.log('cc5' + name + event.target.checked)

    if (type === "checkbox") 
    {
        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: event.target.checked
            }
        })
    } else
    {
        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        })

        var utente = 'utente_unico'
        /*
        axios.get('/ditte/cerca_se_la_ditta_esiste/', {
            params: {
                utente: utente,
                input: JSON.stringify(input)
            }
        }).then((res) => {
//                console.log('ditte trovate')
//                console.log(res.data)
//                SET_lista_ditte(res.data)
            }).catch((error) => {
                console.log(error)
        });
        */
    } 
//    console.log(input);
    
}

function handleClick(event) {
    event.preventDefault();
    
    console.log(input);
    const input_passato = {... input, tutor: props.tutor._id}
    axios.post('/ditte/salva_nuova_ditta', input_passato)
    .then((res) => {
        //                console.log('Aggiunta una classe')
        props.SET_variab_aggiorna(current => !current)
        }).catch((error) => {
        console.log('errore')

    });
    SET_show(false)
    
}

return (
    <>
        <div className="d-flex flex-column flex-grow">
                    <Button onClick={() => SET_show(true)} disabled={false} 
                                                variant= "outline-primary" className="flex-grow">Nuova ditta</Button> 
        </div>
 
        <Modal show={show} onHide={handleClose}   size="lg">
        <Modal.Header closeButton>
            <Modal.Title>Carica una nuova ditta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
                    {/* idroslab  Form basato solo su bootstrap anche con checkbox*/}

        <Form>
                <Scelta_tipologia_azienda setInput = {setInput} input={input}/>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">

                    <Form.Label>Ragione Sociale</Form.Label>
                    <Form.Control onChange={handleChange} type="email" name="ragione_sociale" placeholder="Ragione sociale" value={input.ragione_sociale} autoComplete="off" />
    
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">

                    <Form.Label>Email</Form.Label>
                    <Form.Control onChange={handleChange} name="email" placeholder="email" value={input.email} autoComplete="off" />
    
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">

                    <Form.Label>Partita IVA</Form.Label>
                    <Form.Control onChange={handleChange} name="partita_iva" placeholder="Partita IVA" value={input.partita_iva} autoComplete="off" />

                </Form.Group>

                <Form.Check // prettier-ignore
                    type='checkbox'
                    name='convenzione_in_archivio' 
                    onChange={handleChange}  
                    checked = {input.convenzione_in_archivio}                  
                    label={`Convenzione presente`}
                />
                <Form.Check // prettier-ignore
                    type='checkbox'
                    name='doc_sicurezza_n1_in_archivio' 
                    onChange={handleChange}  
                    checked = {input.doc_sicurezza_n1_in_archivio}                  
                    label={`Doc. Sicurezza n1 presente`}
                />              
                <Form.Check // prettier-ignore
                    type='checkbox'
                    name='doc_sicurezza_n2_in_archivio' 
                    onChange={handleChange}  
                    checked = {input.doc_sicurezza_n2_in_archivio}                  
                    label={`Doc. Sicurezza n2 presente`}
                />  
                
                <div class="d-flex flex-row-reverse">
             
                </div>

            </Form>
       
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
            Annulla
            </Button>

                    {/* idroslab  disabilitazione condizionale*/}

            <Button onClick={handleClick} disabled={input.ragione_sociale == undefined || 
                                                              input.partita_iva == undefined || 
                                                              input.email == undefined || 
                                                              input.tipologia == undefined } 
                                                   className="">Salva</Button> 
        </Modal.Footer>
        </Modal>
    </>
    );

}
export default Nuova_ditta;